var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavoriteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icons__favorite-icon",
    width: "100%",
    height: "100%",
    viewBox: "0 0 1000 1000",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.01971,0,0,2.01971,-483.427,-311.625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.588,181.833C476.094,176.427 481.146,172.672 486.915,172.672C492.683,172.672 497.735,176.427 499.241,181.833L545.208,346.846L721.066,338.295C726.827,338.015 732.066,341.52 733.849,346.846C735.631,352.172 733.514,357.997 728.684,361.057L581.235,454.491L643.954,614.219C646.009,619.452 644.195,625.372 639.528,628.664C634.862,631.956 628.501,631.801 624.01,628.287L486.915,521.019L349.819,628.287C345.328,631.801 338.968,631.956 334.301,628.664C329.634,625.372 327.82,619.452 329.875,614.219L392.594,454.491L245.145,361.057C240.315,357.997 238.198,352.172 239.981,346.846C241.763,341.52 247.002,338.015 252.764,338.295L428.621,346.846L474.588,181.833Z",
    style: {
      fill: "rgb(242,175,13)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteIcon);
export default __webpack_public_path__ + "static/media/favorite-icon.e916cda0242c9cbdbacfa45bd693ccaa.svg";
export { ForwardRef as ReactComponent };